import React, { PureComponent } from "react";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
} from "reactstrap";
import StandardHeader from "components/Headers/HeaderVendor";
import config from "services/config";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import ListInvoice from "./VendorListInvoiceReguler";
class VendorInvoiceReguler extends PureComponent {
  state = {
    listInvoiceVendor: [],
    isFilter: false,
    isFilterLoading: false,
    isResetLoading: false,
    show_custome: true,
    isButton: false,
    listStatus: [],
    national: [],
    select_period: "1",
    select_status: "1",
    min_date: "",
    max_date: "",
    dateSync: {
      dateDay: "",
      date: "1900-01-01 00:00:00",
      dt: "",
      h: "00",
      m: "00",
      s: "00",
      reg: "",
    },
    actionFilter: {
      revision: 0,
      user_id: config.USER_ID,
      company_id: config.COMPANY_ID,
      invoice: "",
    },
    isLoading: false,
    // paramError: {},
    alert: null,
    showActivity: false,
    dataDelivery: {
      company_id: config.COMPANY_ID,
      user_id: config.USER_ID,
      idInvoice: "",
      idDelete: "",
    },
    activity: {
      select_id: "",
    },
  };

  componentDidMount = async () => {
    this.mounted = true;
    this.getListInvoiceVendor();
    this.handleTimeServer();
    this.handleHoliday();
    this.setState({
      listStatus: [
        {
          value: "1",
          label: "Active",
        },
        {
          value: "2",
          label: "Verified",
        },
      ],
    });
  };

  componentWillUnmount() {
    this.mounted = false;
  }
  handleTimeServer = () => {
    axios
      .post(
        config.API_URL + "/vendor/sync_server",
        { id: config.USER_ID,vendor: config.COMPANY_ID },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.TOKEN,
          },
        }
      )
      .then(
        (res) => {
          this.setState({
            ...this.state,
            dateSync: {
              ...this.state.dateSync,
              dateDay: res.data.data.day,
              mt: res.data.data.mt,
              date: res.data.data.dt,
              dtt: res.data.data.dtt,
              h: res.data.data.h,
              m: res.data.data.m,
              s: res.data.data.s,
              reg: res.data.data.reg
            }
          }, () =>this.handleTimeSync()
          )
        },
        (err) => {
          console.log(err.response);
        }
      );
  };
  handleHoliday = () => {
    try {
      axios
        .get(
          "https://raw.githubusercontent.com/guangrei/APIHariLibur_V2/main/calendar.json",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (this.mounted) {
            this.setState({
              national: res.data,
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  actionButton = () => {
    this.setState({});
  };
  getListInvoiceVendor = () => {
    if (this.state.isResetLoading === false) {
      if (this.state.isFilterLoading === false) {
        this.setState({
          isFilterLoading: true,
        });
      }
    }
    // const paramError = validateFilterPeriod(this.state.actionFilter);
    // this.setState({ paramError });
    // if (Object.keys(paramError).length === 0) {
    axios
      .post(
        config.API_URL + "/vendor/list_invoice_vendor",
        this.state.actionFilter,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.TOKEN,
          },
        }
      )
      .then(
        (res) => {
          if (this.mounted) {
            this.setState(
              {
                listInvoiceVendor: res.data.data,
              },
              () => {
                if (this.state.isFilterLoading) {
                  this.setState({
                    isFilterLoading: false,
                    isFilter: true,
                  });
                }
                if (this.state.isResetLoading) {
                  this.setState({
                    isResetLoading: false,
                    isFilter: true,
                  });
                }
              }
            );
          }
        },
        (err) => {
          console.log("error: ", err);
        }
      );
  };
  handleDetails = (e) => {
    this.props.history.push("/vendor/review-reguler-invoice/" + 0 + "/" + e.id);
  };
  handletoAdd = () => {
    this.props.history.push("/vendor/add-reguler-invoice");
  };
  handleFilter = () => {
    this.getListInvoiceVendor();
  };

  handleReset = () => {
    this.setState(
      {
        actionFilter: {
          ...this.state.actionFilter,
          status: "1",
          invoice: "",
          po: "",
        },
        select_status: "1",
        show_custome: false,
        select_period: "1",
      },
      () => {
        if (this.state.isResetLoading === false) {
          this.setState(
            {
              isResetLoading: true,
            },
            () => {
              this.getListInvoiceVendor();
            }
          );
        }
      }
    );
  };

  keyPressed(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }

  handleChangeString = (event) => {
    this.setState(
      {
        actionFilter: {
          ...this.state.actionFilter,
          [event.target.name]: event.target.value,
        },
      },
      () => {
        this.getListInvoiceVendor();
      }
    );
  };
  successAlert = (data) => {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block" }}
          title="Success"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          confirmBtnText="Ok"
          btnSize=""
        >
          {`${data.message}`}
        </SweetAlert>
      ),
    });
  };
  failedAlert = (data) => {
    this.setState({
      alert: (
        <SweetAlert
          danger
          style={{ display: "block" }}
          title="Failed"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Ok"
          btnSize=""
        >
          {`${data.data}`}
        </SweetAlert>
      ),
    });
  };
  hideAlert = () => {
    this.setState({
      alert: null,
    });
  };


  handleTimeSync = (e) => {
    var dateISO = this.state.dateSync.date.substring(0, 10) //2025-01-01
    var national = this.state.national
    var found = Object.entries(national).find(([key, value]) => key === dateISO && value.holiday === true)
    var simFound = found ? true : false
    var dy = this.state.dateSync.dateDay
    var dh = parseInt(this.state.dateSync.h)
    var setAStart = parseInt(9);
    var setAEnd = parseInt(15);
    if(this.state.dateSync.reg === 9){
      this.setState({
        ...this.state, isButton: true
      })
    } else {
      //December
      if (this.state.dateSync.mt === 12) {
        // if (this.state.dateSync.dtt > 0 && this.state.dateSync.dtt < 26 ) {
      //greater than day 25 until less than 39
          if (this.state.dateSync.dtt > 25 && this.state.dateSync.dtt < 30) {
      //equal to greater than hour 9 and hour 17 
            if (dh >= setAStart && dh < 17) {
              this.setState({
                ...this.state, isButton: true
              })
            } else {
              this.setState({ ...this.state, isButton: false })
            }
          } else {
      //regular operational day start monday and thursday
              if (dy > 0 && dy < 5) {
        //regular operational hour start 9:00 and 15:00
                if (dh >= setAStart && dh < setAEnd) {
                  this.setState({
                    ...this.state, isButton: true
                  })
                } else {
                  this.setState({ ...this.state, isButton: false })
                }
            } else {
                this.setState({ ...this.state, isButton: false })
            }
          } 
        // } else {
        //   this.setState({ ...this.state, isButton: false })
        // }
      } else {
        if (this.state.dateSync.dtt > 0 && this.state.dateSync.dtt < 26 && simFound === false) {
          if (dy > 0 && dy < 5) {
            if (dh >= setAStart && dh < setAEnd) {
              this.setState({
                ...this.state, isButton: true
              })
            } else {
              this.setState({ ...this.state, isButton: false })
            }
          } else {
            this.setState({ ...this.state, isButton: false })
          }
        } else {
          this.setState({ ...this.state, isButton: false })
        }
      }
    }
  }

  render() {
    const buttonInvoice = this.state.isButton ? (
      <>
        <Button
          color="success"
          type="button"
          className="btn-icon text-right"
          onClick={() => this.handletoAdd()}
          size="sm"
        >
          <span className="btn-inner--icon mr-1">
            <i className="ni ni-fat-add fa-lg" />
          </span>
          Add
        </Button>
      </>
    ) : (
      <Button
        color="default"
        type="button"
        className="btn-icon text-right"
        size="sm"
        disabled
        style={{
          pointerEvents: "none",
          cursor: "not-allowed !important"
        }}
      >
        <span className="btn-inner--icon mr-1">
          <i className="ni ni-fat-add fa-lg" />
        </span>
        Add
      </Button>
    );
    return (
      <>
        <StandardHeader
          name="Open"
          parentName="Invoice"
          link="active-reguler-invoice"
        />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <ListInvoice
                  list={this.state.listInvoiceVendor}
                  listActivity={this.state.listInvoiceStatusActivity}
                  info={
                    <Col className="col-md-6 col-sm-12  ">
                      <Row>
                        <Col>
                          <InputGroup>
                            <Input
                              bsSize="sm"
                              type="search"
                              // autofocus="autofocus"
                              className="search"
                              id="search"
                              placeholder="Search"
                              result
                              onKeyPress={this.keyPressed}
                              name="invoice"
                              value={this.state.actionFilter.invoice}
                              onChange={this.handleChangeString}
                            // style={{ visibility : this.state.isFilterLoading ? 'hidden' : 'visible'}}
                            />
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              style={{
                                fontSize: "0.9em",
                                height: "31px",
                                border: "1px solid #D6D9DE",
                                borderTopLeftRadius: "0px",
                                borderBottomLeftRadius: "0px",
                              }}
                              onClick={() =>
                                this.setState(
                                  {
                                    actionFilter: {
                                      ...this.state.actionFilter,
                                      invoice: "",
                                    },
                                  },
                                  () => this.getListInvoiceVendor()
                                )
                              }
                            >
                              <i className="fa fa-times-circle text-default" />
                            </button>
                          </InputGroup>
                        </Col>
                        <Col
                          sm={{
                            //  offset: 1,
                            size: "auto",
                          }}
                          xs={{
                            size: "auto",
                          }}
                        >
                          {buttonInvoice}
                        </Col>
                      </Row>
                    </Col>
                  }
                  // actionDelivery={this.handleDelivery}
                  actionStatus={this.handleStatusDetails}
                  details={this.handleDetails}
                />
              </div>
            </div>
          </Row>
          {this.state.alert}
        </Container>
      </>
    );
  }
}
export default VendorInvoiceReguler;
